import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 18px;
    background-color: ${theme.colors.gray.Cinza_13};
    border-radius: 10px;
    padding: 20px;
`;

export const LoadingBox = styled.div`
    width: 74px;
    height: 74px;
    min-width: 74px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Ring = styled.div`
    width: 74px;
    height: 74px;
    min-width: 74px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: conic-gradient(${theme.colors.green.Verde_AgroReceita} ${props => props.percent || 0}%, ${theme.colors.gray.Cinza_11} 0);

    .inner {
        width: 58px;
        height: 58px;
        border-radius: 50%;
        background-color: ${theme.colors.white.Branco};
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Lato;
        font-size: 22px;
        font-weight: 700;
        color: ${theme.colors.gray.Cinza_1};
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const Title = styled.p`
    margin: 0;
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${theme.colors.gray.Cinza_2};
    line-height: 1.3;
`;

export const Subtitle = styled.p`
    margin: 0 0 6px 0;
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${theme.colors.gray.Cinza_7};
    line-height: 1.3;
`;

export const Trend = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    .arrow {
        font-size: 10px;
        color: ${props => props.positive ? theme.colors.green.Verde_AgroReceita : theme.colors.red.Vermelho_erro};
    }

    .percent {
        font-family: Lato;
        font-size: 12px;
        font-weight: 700;
        color: ${props => props.positive ? theme.colors.green.Verde_AgroReceita : theme.colors.red.Vermelho_erro};
    }

    .label {
        font-family: Lato;
        font-size: 12px;
        font-weight: 700;
        color: ${props => props.positive ? theme.colors.green.Verde_AgroReceita : theme.colors.red.Vermelho_erro};
    }
`;
